import axios from 'axios';
import moment from 'moment';

const instance = axios.create({
    timeout: 1500,
});

instance.interceptors.request.use(function (config) {
    config.startTime = moment().toDate();
    return config;
})

instance.interceptors.response.use(function (response) {
    response.time = moment().diff(response.config.startTime);
    return response;
})

export default instance;